import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

const STORAGE_KEY = 'moose:sidebar-collapsed'

export const useUiStore = defineStore('ui', () => {
  const sidebarCollapsed = ref(localStorage.getItem(STORAGE_KEY) === 'true')

  watch(sidebarCollapsed, (value) => {
    localStorage.setItem(STORAGE_KEY, String(value))
  })

  function toggleSidebar(): void {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  return { sidebarCollapsed, toggleSidebar }
})
